import LoopIcon from '@mui/icons-material/Loop';
import * as Styles from './UploadLoading.styles';

export type UploadLoadingProps = {
  id?: string;
  totalOfLoadings?: number;
  isLoading?: boolean;
};

type LoadingType = Partial<UploadLoadingProps> & {
  showIcon?: boolean;
  category: string;
};

export default function UploadLoading({
  totalOfLoadings,
  category,
  id,
  isLoading,
  showIcon,
}: LoadingType): JSX.Element {
  if (!isLoading || !totalOfLoadings || category !== id) {
    return <span data-testid="hidden-loading" />;
  }
  const totalofLoadings = new Array(totalOfLoadings).fill('');
  return (
    <>
      {totalofLoadings.map((_, index) => {
        if (showIcon) {
          return (
            <Styles.Loading key={index.toString()} data-testid="loading-icon">
              <LoopIcon sx={{ color: '#A8BFF2', width: '12.03px', height: '15.03px' }} /> Loading
            </Styles.Loading>
          );
        }
        return (
          <Styles.EmptyField data-testid="loading-empty-line" key={index.toString()}>
            .
          </Styles.EmptyField>
        );
      })}
    </>
  );
}
